// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__zbdr_","background":"styles_background__3cpAV","product":"styles_product__31TB2","picture":"styles_picture__1WELx"};